import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=18c30198&scoped=true&"
import script from "./ViewUser.vue?vue&type=script&lang=js&"
export * from "./ViewUser.vue?vue&type=script&lang=js&"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=18c30198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18c30198",
  null
  
)

export default component.exports